module.exports = __webpack_public_path__ + "img/first-post.d2673258.svg";